import React from 'react'
import { useRecoilState } from 'recoil'
import { toggleMenu as toggleMenuState } from '../../store/uiStore'
import { ToggleMenuButton } from '../../styles/headerStyles'
import { Circle } from '../../assets/svg/icons'

const MenuButton = () => {
  const [toggleMenu, setToggleMenu] = useRecoilState(toggleMenuState)
  return (
    <ToggleMenuButton
      className={[
        toggleMenu ? 'active' : '',
      ]}
      onClick={() => setToggleMenu(!toggleMenu)}
      aria-label='Menú'>
      <div>
        <span />
        <span />
        <span />
      </div>
      <Circle />
    </ToggleMenuButton>
  )
}

export default MenuButton
